import _ from 'underscore';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Pivot, PivotItem } from '@fluentui/react';

import { AdPreviewSurface, AdPreviewSurfaceHeaderText } from '../const';

export const AdAssetsPreviewerControls = (props) => {
  const {
    selectedSurface,
    onSurfaceChange,
  } = props;
  const handleSurfaceChange = useCallback((item => onSurfaceChange(item.props.itemKey)), [onSurfaceChange]);

  return (
    <div className="ad-previewer-controls">
      <Pivot selectedKey={selectedSurface} onLinkClick={handleSurfaceChange}>
        {_.map(AdPreviewSurface, surface => (
          <PivotItem itemKey={surface} headerText={AdPreviewSurfaceHeaderText[surface]} />
      ))}
      </Pivot>
    </div>
  );
};

AdAssetsPreviewerControls.propTypes = {
  selectedSurface: PropTypes.string.isRequired,
  onSurfaceChange: PropTypes.func.isRequired,
};
